var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 8V12C2.66699 12.7353 3.26467 13.333 4 13.333H12C12.7353 13.333 13.333 12.7353 13.333 12V8H16V12C16 14.206 14.206 16 12 16H4C1.794 16 0 14.206 0 12V8H2.66699ZM8 0C8.73656 0 9.33283 0.597157 9.33301 1.33301V6H11.0576C11.6514 6.00023 11.9483 6.71776 11.5283 7.1377L8 10.667L4.47168 7.1377C4.05175 6.71776 4.34857 6.00023 4.94238 6H6.66699V1.33301C6.66717 0.597157 7.26344 2.31825e-07 8 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.80784e31d003aa7f53e2639f08e5a5fe.svg";
export { ForwardRef as ReactComponent };